import {
  axiosPost,
  axiosGet,
  axiosDelete,
  axiosPut,
} from '../plugins/axios.plugins';

const API_ENDPOINTS = {
  REPORT_PDF_BASEURL: `${process.env.VUE_APP_PDF_GENERATOR_API}`,
  WORKFLOW_BASEURL: `${process.env.VUE_APP_DATA_API}`,
  FLOW_RUNNER_BASEURL: `${process.env.VUE_APP_FLOW_RUNNER_API}`,
  WRITE_MESSAGE_BASEURL: `${process.env.VUE_APP_WRITE_MESSAGE_API}`,
  FORM_BUILDER_BASEURL: `${process.env.VUE_APP_FORM_BUILDER_API}`,
  EU_CENTRAL_FORM_GENERATOR_BASEURL: `${process.env.VUE_APP_EU_CENTRAL_FORM_GENERATOR_API}`,
};

const generatePdf = (payload) => {
  return axiosPost(
    `${API_ENDPOINTS.REPORT_PDF_BASEURL}/generate-page`,
    payload
  );
};

const getWorkFlowById = (workFlowId) => {
  return axiosGet(`${API_ENDPOINTS.WORKFLOW_BASEURL}/get-flow/${workFlowId}`);
};

const runFlowById = (params = '', payload = {}) => {
  return axiosPost(
    `${API_ENDPOINTS.FLOW_RUNNER_BASEURL}/run_flow_by_id${params}`,
    payload
  );
};

const askChatGPT = (workflowUrl, payload) => {
  return axiosPost(`${workflowUrl}/ask-gpt`, payload);
};

const deleteWorkflowById = (workFlowId) => {
  return axiosDelete(`${API_ENDPOINTS.WORKFLOW_BASEURL}/flow/${workFlowId}`);
};

const getWorkFlowAccessRights = (workFlowId) => {
  return axiosGet(`${API_ENDPOINTS.WORKFLOW_BASEURL}/flow/iam/${workFlowId}`);
};

const shareWorkFlow = (payload, customNotFoundRedirect = false) => {
  return axiosPut(
    `${API_ENDPOINTS.WORKFLOW_BASEURL}/flow/share`,
    payload,
    customNotFoundRedirect ? { customNotFoundRedirect } : {}
  );
};

const generateFlowHtml = (payload, formBuilderVersion = 'v5') => {
  const formGeneratorUrl =
    parseInt(formBuilderVersion.slice(1)) <= 6
      ? API_ENDPOINTS.FORM_BUILDER_BASEURL
      : API_ENDPOINTS.EU_CENTRAL_FORM_GENERATOR_BASEURL;

  return axiosPost(
    `${formGeneratorUrl}/${formBuilderVersion}/get_form_as_file`,
    payload
  );
};

const getMapJson = (payload, apiEndpoint) => {
  const apiEndpointURL = apiEndpoint
    ? apiEndpoint
    : API_ENDPOINTS.FLOW_RUNNER_BASEURL;
  return axiosPost(`${apiEndpointURL}/map-json`, payload);
};

export {
  generatePdf,
  getWorkFlowById,
  runFlowById,
  askChatGPT,
  deleteWorkflowById,
  getWorkFlowAccessRights,
  shareWorkFlow,
  generateFlowHtml,
  getMapJson,
};
